import Swiper from 'swiper';
import 'swiper/css';

const initializeProdutosHome = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const produtosSection = document.querySelector("#descricao-produtos");
    if (!produtosSection) return;

    const cards = document.querySelectorAll("[data-card]");
    const fundos = document.querySelectorAll("[data-bg]");
    const iconesInterativos = produtosSection.querySelectorAll("g.icone-interativo");
    let swiperMobile = null;

    if (window.matchMedia('(max-width: 1024px)').matches) {
      swiperMobile = new Swiper('#swiper-cards-mobile', {
        slidesPerView: 1.2,
        spaceBetween: 32,
				centeredSlides: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
				breakpoints:{
					0:{
						slidesPerView: 1.2,
					},
					500:{
						slidesPerView: 'auto',
					}
				}
      });
    }

    const garantirGradienteVerdeNoSVG = (svg) => {
      if (!svg.querySelector('#gradiente-verde')) {
        const SVG_NS = "http://www.w3.org/2000/svg";
        const defs = document.createElementNS(SVG_NS, "defs");
        const linearGradient = document.createElementNS(SVG_NS, "linearGradient");

        linearGradient.setAttribute("id", "gradiente-verde");
        linearGradient.setAttribute("x1", "0%");
        linearGradient.setAttribute("y1", "0%");
        linearGradient.setAttribute("x2", "100%");
        linearGradient.setAttribute("y2", "0%");

        const stop1 = document.createElementNS(SVG_NS, "stop");
        stop1.setAttribute("offset", "0%");
        stop1.setAttribute("stop-color", "#b8945c");
        stop1.setAttribute("stop-opacity", "1");

        const stop2 = document.createElementNS(SVG_NS, "stop");
        stop2.setAttribute("offset", "100%");
        stop2.setAttribute("stop-color", "#9c7b3a");
        stop2.setAttribute("stop-opacity", "1");

        linearGradient.appendChild(stop1);
        linearGradient.appendChild(stop2);
        defs.appendChild(linearGradient);

        svg.prepend(defs);
      }
    };

    const ativarTipo = (tipo) => {
      cards.forEach((card) => {
        const svgAtivo = card.querySelector('svg.linha-card-ativado');
        const path = svgAtivo ? svgAtivo.querySelector('path') : null;

        if (card.getAttribute("data-card") === tipo) {
          if (svgAtivo && path) {
            garantirGradienteVerdeNoSVG(svgAtivo);
            path.setAttribute("fill", "url(#gradiente-verde)");
          }
        } else {
          if (svgAtivo && path) {
            path.setAttribute("fill", "url(#paint0_linear_4358_5462)");
          }
        }
      });

      fundos.forEach((fundo) => {
        if (fundo.getAttribute("data-bg") === tipo) {
          fundo.style.opacity = "1";
          fundo.style.pointerEvents = "auto";
        } else {
          fundo.style.opacity = "0";
          fundo.style.pointerEvents = "none";
        }
      });

      if (swiperMobile) {
        const slides = document.querySelectorAll("#swiper-cards-mobile .swiper-slide");
        slides.forEach((slide, index) => {
          if (slide.getAttribute("data-card") === tipo) {
            swiperMobile.slideTo(index, 500);
          }
        });
      }
    };

  const aplicarEstiloClique = (tipoAtivo) => {
  iconesInterativos.forEach((icone) => {
    const grupo = icone.querySelector('[data-icone]');
    const tipo = grupo?.getAttribute("data-icone");
    const fundo = icone.querySelector(".icone-fundo");
    const normais = icone.querySelectorAll(".icone-normal");
    const fundoBranco = icone.querySelector(".fundo-branco");

    if (tipo === tipoAtivo) {
      icone.classList.add("ativo"); 

      if (fundo) {
        fundo.setAttribute("fill", "#f3ecdc");
        fundo.removeAttribute("fill-opacity");
      }

      normais.forEach((n) => {
        n.setAttribute("stroke", "rgba(156, 123, 58, 1)");
        n.setAttribute("fill-opacity", "1");
      });

      if (fundoBranco) {
        fundoBranco.setAttribute("fill", "#f3ecdc");
        fundoBranco.removeAttribute("fill-opacity");
      }
    } else {
      icone.classList.remove("ativo");

      if (fundo) {
        fundo.setAttribute("fill", "currentColor");
        fundo.setAttribute("fill-opacity", "0.05");
      }

      normais.forEach((n) => {
        n.setAttribute("stroke", "white");
        n.setAttribute("fill-opacity", "0.12");
      });

      if (fundoBranco) {
        fundoBranco.setAttribute("fill", "currentColor");
        fundoBranco.setAttribute("fill-opacity", "0.05");
      }
    }
  });
};


    // Evento para ícones
    iconesInterativos.forEach((icone) => {
      const grupo = icone.querySelector('[data-icone]');
      const tipo = grupo?.getAttribute("data-icone");
      if (!tipo) return;

      icone.style.cursor = "pointer";

      icone.addEventListener("click", () => {
        ativarTipo(tipo);
        aplicarEstiloClique(tipo);
      });
    });

    // Evento para os fundos-brancos
    const fundosBrancos = produtosSection.querySelectorAll(".fundo-branco");
    fundosBrancos.forEach((fundoEl) => {
      fundoEl.style.cursor = "pointer";

      fundoEl.addEventListener("click", (e) => {
        // Para garantir que só reaja se for mobile (opcional)
        if (!window.matchMedia('(max-width: 1024px)').matches) return;

        // Encontra o pai mais próximo que tem o data-icone
        const iconePai = fundoEl.closest("g.icone-interativo");
        if (!iconePai) return;

        const grupo = iconePai.querySelector('[data-icone]');
        const tipo = grupo?.getAttribute("data-icone");
        if (!tipo) return;

        ativarTipo(tipo);
        aplicarEstiloClique(tipo);
      });
    });

    // Ativa inicialmente o ícone commodities-futuros-fundo
    const inicial = produtosSection.querySelector('g.icone-interativo g[data-icone="commodities-futuros-fundo"]');
    if (inicial) {
      const iconePai = inicial.closest("g.icone-interativo");
      const tipo = inicial.getAttribute("data-icone");
      if (iconePai && tipo) {
        ativarTipo(tipo);
        aplicarEstiloClique(tipo);
      }
    }
  });
};

export default initializeProdutosHome; 